export default __webpack_public_path__ + "static/media/button-img-toggle.1ba1345c.svg";